const _socialLink = [
    {
        href: "https://x.com/btaftoken",
        title: "twitter",
        icon: "https://btaftoken.io/wp-content/uploads/2025/04/x-1.svg",
    },
    {
        href: "https://t.me/+fxG_sPS4AQA0ODdl",
        title: "telegram",
        icon: "https://btaftoken.io/wp-content/uploads/2025/04/telegrame.svg",
    },
    {
        href: "https://medium.com/@TAFtoken",
        title: "medium",
        icon: "	https://btaftoken.io/wp-content/uploads/2025/04/medium.svg",
    },
    {
        href: "https://www.youtube.com/channel/UCQ_UZw1Av5cSsQ6BB9Wq63g",
        title: "youtube",
        icon: "https://btaftoken.io/wp-content/uploads/2025/04/youtube.svg",
    },
    {
        href: "https://www.facebook.com/btaftoken.io",
        title: "facebook",
        icon: "https://btaftoken.io/wp-content/uploads/2025/04/facebook.svg",
    },
    {
        href: "https://bitcointaf.com/btaf-token-nfts/",
        title: "nft",
        icon: "	https://btaftoken.io/wp-content/uploads/2025/04/NFT2-1.svg",
    },
    {
        href: "https://github.com/BTafPremiere",
        title: "git",
        icon: "	https://btaftoken.io/wp-content/uploads/2025/04/github.svg",
    },
    {
        href: "https://www.instagram.com/Taftoken",
        title: "instagram",
        icon: "https://btaftoken.io/wp-content/uploads/2025/04/insta.svg",
    },
    {
        href: "https://app.bitcointaf.com/auth/register/",
        title: "support",
        icon: "	https://btaftoken.io/wp-content/uploads/2025/12/BTAF-Token-Support-Team-scaled.png",
    },
];

export default _socialLink;
